import Vue from 'vue'
import App from './App'
import 'babel-polyfill'
import './style/font.css'
import moment from 'moment'//导入文件
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import {post, get, exportMethod} from './api/api'
import {baseUrl} from '@/config/env.js';
import {cache} from './api/localCache'
import './api/filter'//全局过滤器

//定义全局变量,挂载到Vue实例上面
// Vue.prototype.$print = print;//赋值使用
Vue.use(ElementUI);
Vue.config.productionTip = false;
moment.locale('zh-cn');//需要汉化
Vue.prototype.$moment = moment;//赋值使用
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$exportMethod = exportMethod;
Vue.prototype.baseUrl = baseUrl;
Vue.prototype.localCache = cache
// 用户全局信息
Vue.prototype.subimitCode = "wms-submit-code";

//定义全局变量,挂载到Vue实例上面
Vue.prototype.$moment = moment;//赋值使用
//国际化
import i18n from './lang/i18n'

/* 监测路由*/
router.beforeEach((to, from, next) => {
  if (!Vue.prototype.localCache.msg) {
    if (to.path === '/' || to.path === '/testPrinter' || to.path === '/cloudPrinter') {
      next();
    } else {
      next("/");
    }
  } else {
    next();
  }
});

Vue.directive('focus', function (el, option) {
  let defClass = 'el-input', defTag = 'input';
  let value = option.value || false;
  if (typeof value === 'boolean')//页面中只有一个组件用到v-focus指令 v-focus='true'
    value = {cls: defClass, tag: defTag, foc: value};
  else//页面有多个组件用到v-focus指令
    value = {cls: value.cls || defClass, tag: value.tag || defTag, foc: value.foc || false};
  if (el.classList.contains(value.cls) && value.foc)//当页面中包含defclass，且foc属性为true时
    el.getElementsByTagName(value.tag)[0].focus();//设置tag的第一个元素聚焦
});

// 定义实例
new Vue({
  el: '#app',
  i18n,
  router,
  components: {App},
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js